import { AssetDto } from '@nusign/picflow-backend-types';
import { downloadSizes } from '../consts';
import { GalleryAccessLevel } from './access-level';
import { paddTo } from './padd-to';

export const convertGalleryDownloadSize = (number: number) => {
  const maxSize = Math.pow(2, downloadSizes.length) - 1;
  const enabledDownloadSizes: { [key: string]: boolean } = {};

  if (number > maxSize) {
    downloadSizes.filter(s => s.name !== 'reserved').forEach(size => (enabledDownloadSizes[size.name] = true));
  } else {
    const downloadSizesString = paddTo((number >>> 0).toString(2), 8);
    downloadSizes.forEach((size, i) => {
      enabledDownloadSizes[size.name] = downloadSizesString[i] === '1';
    });
  }
  return enabledDownloadSizes;
};

export const getAllowedDownloadSizes = (number: number, accessLevel: GalleryAccessLevel, asset: AssetDto) => {
  let sizes: {
    name: string;
    size?: number;
  }[] = downloadSizes;

  let allowOriginalDownload = false;

  const enabledSizes = convertGalleryDownloadSize(number);
  if (accessLevel !== 'edit') {
    sizes = sizes.filter(s => enabledSizes[s.name] && s.name !== 'original' && s.name !== 'reserved');
    const assetIsWatermarked = !!asset.version_data.watermark_uuid && asset.watermark_enabled;
    allowOriginalDownload = enabledSizes.original && !assetIsWatermarked;
  } else {
    allowOriginalDownload = true;
  }
  if (asset.type === 'video') {
    allowOriginalDownload = true;
  }

  if (asset.type === 'video') {
    sizes = [];
  } else {
    const filteredSizes = asset.version_data.data?.width
      ? sizes.filter(s => asset.version_data.data.width >= s.size && enabledSizes[s.name])
      : [];
    if (!filteredSizes.length) {
      // no sizes are big enough, and the original is not allowed to be download, so in this case we allow the download of the smallest allowed size
      const smallest = sizes.find(s => enabledSizes[s.name]);
      if (smallest && asset.version_data.data?.width) filteredSizes.push(smallest);
    }
    sizes = filteredSizes.filter(s => s.name !== 'original');
  }

  return {
    sizes,
    allowOriginalDownload,
  };
};
